export const Dashboard: React.FC = () => {

    return (
        <div className="bfs-dashboard-page">
            Dashboard
        </div>
    )
}